/**
 * Cometa Taller · Navegación y Mega-menú Accesible
 *
 * Cumple con Sección 7.9:
 * - El mega-menú se abre con clic y foco con teclado.
 * - Se cierra con la tecla Escape y con clic fuera del panel.
 * - Trampas de foco y estados aria-expanded actualizados correctamente.
 */

export function initNav() {
  const navTrigger = document.querySelectorAll('[data-ct-megamenu-trigger]');
  const megaMenu = document.querySelector('[data-ct-megamenu]');
  const megaCloseButtons = document.querySelectorAll('[data-ct-megamenu-close]');

  if (!megaMenu) return;

  function abrirMenu(trigger) {
    megaMenu.classList.add('is-open');
    megaMenu.setAttribute('aria-hidden', 'false');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      const linea = trigger.getAttribute('data-ct-linea');
      if (linea) {
        activarPanelLinea(linea);
      }
    }
  }

  function cerrarMenu() {
    megaMenu.classList.remove('is-open');
    megaMenu.setAttribute('aria-hidden', 'true');
    navTrigger.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
  }

  function activarPanelLinea(linea) {
    const paneles = megaMenu.querySelectorAll('[data-ct-megamenu-panel]');
    const tabs = megaMenu.querySelectorAll('[data-ct-megamenu-tab]');

    paneles.forEach((p) => {
      p.hidden = p.getAttribute('data-ct-megamenu-panel') !== linea;
    });

    tabs.forEach((t) => {
      const activo = t.getAttribute('data-ct-megamenu-tab') === linea;
      t.classList.toggle('is-active', activo);
      t.setAttribute('aria-selected', activo ? 'true' : 'false');
    });
  }

  navTrigger.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = megaMenu.classList.contains('is-open');
      const currentLinea = btn.getAttribute('data-ct-linea');
      const activePanel = megaMenu.querySelector('[data-ct-megamenu-panel]:not([hidden])');
      const activeLinea = activePanel ? activePanel.getAttribute('data-ct-megamenu-panel') : null;

      if (isOpen && activeLinea === currentLinea) {
        cerrarMenu();
      } else {
        abrirMenu(btn);
      }
    });
  });

  megaCloseButtons.forEach((btn) => {
    btn.addEventListener('click', cerrarMenu);
  });

  // Cerrar con Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && megaMenu.classList.contains('is-open')) {
      cerrarMenu();
    }
  });

  // Cerrar al hacer clic fuera del header y mega-menú
  document.addEventListener('click', (e) => {
    if (megaMenu.classList.contains('is-open')) {
      const isInside = megaMenu.contains(e.target) || e.target.closest('.ct-nav');
      if (!isInside) {
        cerrarMenu();
      }
    }
  });

  // Tabs internas del mega-menú
  const tabs = megaMenu.querySelectorAll('[data-ct-megamenu-tab]');
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const linea = tab.getAttribute('data-ct-megamenu-tab');
      activarPanelLinea(linea);
    });
  });
}
